module.exports = __webpack_public_path__ + "static/media/rockWallSheetMiddle.dffaad60.png";